import { render } from "./MyGroup.vue?vue&type=template&id=39d26e6f&scoped=true"
import script from "./MyGroup.vue?vue&type=script&lang=js"
export * from "./MyGroup.vue?vue&type=script&lang=js"

import "./MyGroup.vue?vue&type=style&index=0&id=39d26e6f&lang=css"
import "./MyGroup.vue?vue&type=style&index=1&id=39d26e6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d26e6f"]])

export default __exports__